import RewardsCalculator from '@ulta/core/components/RewardsCalculator/RewardsCalculator';

export default RewardsCalculator;
